import { render, staticRenderFns } from "./coursedetails.vue?vue&type=template&id=6833b774&scoped=true&"
import script from "./coursedetails.vue?vue&type=script&lang=js&"
export * from "./coursedetails.vue?vue&type=script&lang=js&"
import style0 from "./coursedetails.vue?vue&type=style&index=0&id=6833b774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833b774",
  null
  
)

export default component.exports